/* global wp */
const {render} = wp.element;
import ImportLayoutModal from './ImportLayoutModal';

var templateAddSection = jQuery("#tmpl-elementor-add-section");

if (0 < templateAddSection.length) {
    var oldTemplateButton = templateAddSection.html();
    var log_path = rttpgParams.plugin_url + '/assets/images/icon-40x40.svg'

    oldTemplateButton = oldTemplateButton.replace(
        '<div class="elementor-add-section-drag-title',
        '<div class="elementor-add-section-area-button rttpg-import-button" style="vertical-align: bottom;margin-left: 5px;padding:0"><img src="' + log_path + '" alt="TPG"/></div><div class="elementor-add-section-drag-title'
    );
    templateAddSection.html(oldTemplateButton);

    function replaceKey(obj, targetKey, newKey) {
        for (let key in obj) {
            if (key === targetKey) {
                obj[newKey] = obj[key];
                delete obj[key];
            } else if (typeof obj[key] === "object") {
                replaceKey(obj[key], targetKey, newKey);
            }
        }
        return obj;
    }

    function replaceVal(obj, targetKey, returnVal) {
        for (let key in obj) {
            if (key === targetKey) {
                obj[targetKey] = returnVal || {}; //obj[key];
            } else if (typeof obj[key] === "object") {
                replaceVal(obj[key], targetKey, returnVal);
            }
        }
        return obj;
    }

    const importLayout = (content, insertIndex) => {
        let newContent = JSON.parse(content);
        let modifiedData = newContent.map(item => {
            return {...item, id: Math.random().toString(16).slice(2)}
        });

        replaceVal(modifiedData, "category_ids", "");
        replaceVal(modifiedData, 'orderby', 'date');
        replaceVal(modifiedData, 'order', 'DESC');
        replaceVal(modifiedData, 'offset', '');

        if (undefined != insertIndex && insertIndex != -1 ) {
            if(insertIndex > 1){
                insertIndex -= 1;
            }
            elementor.getPreviewView().addChildModel(modifiedData, {at: insertIndex, silent: 0});
        } else {
            elementor.getPreviewView().addChildModel(modifiedData, {silent: 0});
        }

        elementor.channels.data.trigger('template:after:insert', {});

        if (undefined != $e && 'undefined' != typeof $e.internal) {
            $e.internal('document/save/set-is-modified', {status: true})
        } else {
            elementor.saver.setFlagEditorChange(true);
        }
        window.tmPromo.destroy();
        // window.tmPromo.hide();
    }


    wp.domReady(function () {

        elementor.on("preview:loaded", function () {
            jQuery(elementor.$previewContents[0].body).on("click", ".rttpg-import-button", function (event) {
                const insertIndex = 0 < jQuery(this).parents(".elementor-section-wrap").length ? jQuery(this).parents(".elementor-add-section").index() : -1;
                window.tmPromo = elementorCommon.dialogsManager.createWidget(
                    "lightbox",
                    {
                        id: "rttpg-import-template-wrapper",
                        headerMessage: !1,
                        message: "",
                        hide: {
                            auto: !1,
                            onClick: !1,
                            onOutsideClick: false,
                            onOutsideContextMenu: !1,
                            onBackgroundClick: !0,
                        },
                        position: {
                            my: "center",
                            at: "center",
                        },
                        onShow: function () {
                            var contentTemp = jQuery(".dialog-content-tempromo")

                            const rttpgImportWrap = document.createElement("div");
                            rttpgImportWrap.classList.add("rttpg-import-wrapper-inner");
                            render(<ImportLayoutModal importLayout={importLayout}
                                                      insertIndex={insertIndex}/>, rttpgImportWrap);

                            contentTemp.addClass('rttpg-import-main-wrapper');
                            contentTemp.html(rttpgImportWrap);
                        },
                        onHide: function () {
                            window.tmPromo.hide();
                        }
                    }
                );
                window.tmPromo.getElements("header").remove();
                window.tmPromo.getElements("message").append(
                    window.tmPromo.addElement("content-tempromo")
                );
                window.tmPromo.show();
            });
        });


    });

}